<template>
  <div class="break-time" />
</template>

<script>
export default {
  name: 'BreakTimeBlock',
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.break-time {
	width: 100%;
	height: 50px;
	color: white;
	text-align: center;
	line-height: 50px;
	font-weight: bold;
	background-color: rgba(255, 255, 255, 0.3);
}
</style>
